import cn from 'classnames';

import { ProfilePublic } from '../profilePublic/ProfilePublic';

import styles from './ProfileTrust.module.css';
import type { ProfileIdentity } from '@/domain';

export type ProfileTrustProps = {
    profileIdentity?: ProfileIdentity;
};

export const ProfileTrust = ({ profileIdentity }: ProfileTrustProps) => (
    <div data-testid="trustProfile">
        <div className={cn(styles.container, 'finn-trust-profile text-left')}>
            <ProfilePublic identity={profileIdentity} />
        </div>
    </div>
);
